import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import SessionsTable from "../container/Program/SessionsTable";

const handbookUrl = `${process.env.PUBLIC_URL}/files/ICSI2026_Program_Handbook.pdf`;

const Sessions = () => {
  return (
    <React.Fragment>
      <SEO title="Sessions | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Sessions"
        content="The Conference"
        contentTwo="Sessions"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content title-center">
          <h2>ICSI&apos;2026 Detailed Session Schedule</h2>
          <p>
            <a
              className="btn btn-primary btn-hover-secondary mt-s"
              href={handbookUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Program Handbook (PDF)
            </a>
          </p>
        </div>
        <div className="entry-content title-center">
          <SessionsTable />
        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Sessions;
